// extracted by mini-css-extract-plugin
module.exports = {"componentsMapTabs":"styles_componentsMapTabs__EyNkg"};